import { render, staticRenderFns } from "./SimpleStackedChart.vue?vue&type=template&id=6cf0780b&"
import script from "./SimpleStackedChart.vue?vue&type=script&lang=js&"
export * from "./SimpleStackedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports